/* eslint-disable radix */
/* eslint-disable jsx-a11y/label-has-associated-control */
import {
  Box,
  Button,
  Flex,
  IconButton,
  Input,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import useGetAll from "hooks/useGetAll";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import Select from "react-select";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { getTrainerClients } from "services/clients";
import { generateNutrition } from "services/nutrition";
import useLang from "hooks/useLang";
import TypingEffect from "./TypingEffect";
import LoadingResponseNutrition from "./LoadingResponse";
import { generatePromptNutrition } from "./propmt";
import ModalSaveNutrition from "./ModalSaveNutrition";
import CustomNutrition from "./CustomNutrition";

const Nutrition = () => {
  const { id_user } = useSelector(({ user }) => user);
  const { t, lang } = useLang();
  const initialRef = useRef();
  const [response, setResponse] = useState("");
  const { data: dataNameClient } = useGetAll("clients", id_user, getTrainerClients);
  const [client, setClient] = useState("");
  const [snack, setSnack] = useState(0)
  const [clientName, setClientName] = useState("");
  const [diet, setDiet] = useState("");
  const [loader, setloader] = useState(false);
  const [foodAvoid, setFoodAvoid] = useState("");
  const [foodInclude, setFoodInclude] = useState("");
  const [meal, setMeal] = useState(0);
  const [shake, setShake] = useState(0);
  const [calories, setCalories] = useState(0);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [protein, setProtein] = useState(30);
  const [fat, setFat] = useState(30);
  const [carbs, setCarbs] = useState(40);

  const calcularMacronutrientes = () => {
    const caloriasCarbohidratos = (calories * carbs) / 100;
    const caloriasProteinas = (calories * protein) / 100;
    const caloriasGrasas = (calories * fat) / 100;

    const gramosCarbohidratos = caloriasCarbohidratos / 4;
    const gramosProteinas = caloriasProteinas / 4;
    const gramosGrasas = Math.round(caloriasGrasas / 9);

    return {
      gramosCarbohidratos,
      gramosProteinas,
      gramosGrasas,
    };
  };

  const { gramosCarbohidratos, gramosProteinas, gramosGrasas } = calcularMacronutrientes();

  const handleProteinChange = (e) => {
    const newProtein = parseInt(e.target.value);
    const maxFat = 100 - newProtein;
    const newFat = fat > maxFat ? maxFat : fat;
    const newCarbs = 100 - newProtein - newFat;
    setProtein(newProtein);
    setFat(newFat);
    setCarbs(newCarbs);
  };

  const handleFatChange = (e) => {
    const newFat = parseInt(e.target.value);
    const maxProtein = 100 - newFat;
    const newProtein = protein > maxProtein ? maxProtein : protein;
    const newCarbs = 100 - newProtein - newFat;
    setFat(newFat);
    setProtein(newProtein);
    setCarbs(newCarbs);
  };

  const inc = () => {
    if (meal < 20) setMeal(meal + 1);
  };
  const dec = () => {
    if (meal > 0) setMeal(meal - 1);
  };
  const incSnake = () => {
    if (shake < 20) setShake(shake + 1);
  };
  const decSnake = () => {
    if (shake > 0) setShake(shake - 1);
  };
  const incSnack = () => {
    if (snack < 20) setSnack(snack + 1);
  };
  const decSnack = () => {
    if (snack > 0) setSnack(snack - 1);
  };

  const options = dataNameClient?.map(({ name, lastName, _id }) => {
    const returnOptions = {
      value: _id,
      label: `${name} ${lastName || ""}`,
    };
    return returnOptions;
  });

  const chooseClient = (e) => {
    setClient(e.value);
    setClientName(e.label);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const message = generatePromptNutrition({
      lang,
      protein,
      fat,
      carbs,
      meal,
      shake,
      foodAvoid,
      foodInclude,
      calories,
      diet,
      snack
    });

    try {
      setloader(true);
      const res = await generateNutrition({ message });
      setloader(false);
      const formattedText = res.response
        .replace(/\n/g, "<br />")
        .replace(/\*\*(.*?)\*\*/g, "<b>$1</b>");
      setResponse(formattedText);
    } catch (error) {
      console.error("Error fetching data from ChatGPT:", error);
      setResponse("Sorry, have a error.");
    }
  };

  const handleTryAdain = async (e) => {
    e.preventDefault();

    const message =
      lang === "en"
        ? `give me another diet, remove markdown formatting, ${generatePromptNutrition({
            lang,
            protein,
            fat,
            carbs,
            meal,
            shake,
            foodAvoid,
            foodInclude,
            calories,
            diet,
            snack
          })}`
        : `dame otra dieta, , remueve el formato markdown, ${generatePromptNutrition({
            lang,
            protein,
            fat,
            carbs,
            meal,
            shake,
            foodAvoid,
            foodInclude,
            calories,
            diet,
            snack
          })}`;

    try {
      setloader(true);
      const res = await generateNutrition({ message });
      setloader(false);
      const formattedText = res.response
        .replace(/\n/g, "<br />")
        .replace(/\*\*(.*?)\*\*/g, "<b>$1</b>");
      setResponse(formattedText);
    } catch (error) {
      console.error("Error fetching data from ChatGPT:", error);
      setResponse("Sorry, have a error.");
    }
  };
  return (
    <Tabs isFitted variant="enclosed">
      <TabList mb="1em">
        <Tab>Express</Tab>
        <Tab>Custom</Tab>
      </TabList>
      <TabPanels>
        <TabPanel>
          <Box display="flex" flexWrap="wrap">
            <Box
              w={{ base: "100%", md: "50%" }}
              p={5}
              display="flex"
              flexDirection="column"
              style={{ gap: "1rem" }}>
              <h3 style={{ fontSize: "34px", lineHeight: "2rem" }}>
                {t("nutrition_section.header")}{" "}
                <span style={{ color: "#b42519", fontWeight: "bold" }}>Perfect Trainer</span>{" "}
                {t("using")} <span style={{ color: "#b42519", fontWeight: "bold" }}>IA</span>
              </h3>
              <Box width="full" display="flex" justifyContent="space-between">
                <Box>
                  <span>{t("nutrition_section.assign_nutrition")}</span>
                  <Select
                    placeholder={t("select_a_client")}
                    options={options}
                    onChange={chooseClient}
                  />
                </Box>
                <Box>
                  <label>Total Calories</label>
                  <Input
                    placeholder="Write calores"
                    name="calories"
                    value={calories}
                    onChange={(e) => setCalories(e.target.value)}
                  />
                </Box>
              </Box>
              <Box>
                <span>{t("nutrition_section.diet_styles")}</span>
                <Input
                  placeholder="Write diet"
                  name="diet"
                  value={diet}
                  onChange={(e) => setDiet(e.target.value)}
                />
              </Box>
              <h4>{t("nutrition_section.macronutrients")}</h4>
              <Box
                display="flex"
                justifyContent="space-between"
                bg="white"
                p={2}
                borderRadius="10px">
                <div>
                  <Box>
                    <label>
                      {t("nutrition_section.protein_percentage")} {protein}%
                    </label>
                    <Text fontSize="14px">
                      <p>
                        {t("nutrition_section.grams")} {gramosProteinas}g
                      </p>
                    </Text>
                  </Box>
                  <input
                    type="range"
                    min="0"
                    max="100"
                    value={protein}
                    onChange={handleProteinChange}
                  />
                </div>
                <div>
                  <Box>
                    <label>
                      {t("nutrition_section.carbs_percentage")} {carbs}%
                    </label>
                    <Text fontSize="14px">
                      <p>
                        {t("nutrition_section.grams")} {gramosCarbohidratos}g
                      </p>
                    </Text>
                  </Box>

                  <input type="range" min="0" max="100" disabled value={carbs} readOnly />
                </div>
                <div>
                  <Box>
                    <label>
                      {t("nutrition_section.fats_percentage")} {fat}%
                    </label>
                    <Text fontSize="14px">
                      <p>
                        {t("nutrition_section.grams")} {gramosGrasas}g
                      </p>
                    </Text>
                  </Box>
                  <input type="range" min="0" max="100" value={fat} onChange={handleFatChange} />
                </div>
              </Box>
              <Box display="flex" justifyContent="space-between">
                <VStack align="stretch" mb={4}>
                  <label htmlForm="meal" style={{ fontSize: "1.1rem" }}>
                    {t("nutrition_section.meals_per_day")}
                  </label>
                  <Flex gridGap={4}>
                    <IconButton
                      isRound
                      icon={<RemoveIcon fontSize="inherit" />}
                      onClick={dec}
                      disabled={meal <= 0}
                    />
                    <Input
                      variant="filled"
                      type="number"
                      min={0}
                      max={20}
                      bg="white"
                      value={meal}
                      onChange={(e) => setMeal(e.target.value)}
                    />
                    <IconButton
                      isRound
                      icon={<AddIcon fontSize="inherit" />}
                      onClick={inc}
                      disabled={meal >= 10}
                    />
                  </Flex>
                </VStack>

                <VStack align="stretch" mb={4}>
                  <label htmlForm="meal" style={{ fontSize: "1.1rem" }}>
                    {t("nutrition_section.snack")}
                  </label>
                  <Flex gridGap={4}>
                    <IconButton
                      isRound
                      icon={<RemoveIcon fontSize="inherit" />}
                      onClick={decSnack}
                      disabled={snack <= 0}
                    />
                    <Input
                      variant="filled"
                      type="number"
                      min={0}
                      max={20}
                      bg="white"
                      value={snack}
                      onChange={(e) => setSnack(e.target.value)}
                    />
                    <IconButton
                      isRound
                      icon={<AddIcon fontSize="inherit" />}
                      onClick={incSnack}
                      disabled={snack >= 10}
                    />
                  </Flex>
                </VStack>

                <VStack align="stretch" mb={4}>
                  <label htmlForm="meal" style={{ fontSize: "1.1rem" }}>
                    {t("nutrition_section.protein_skake")}
                  </label>
                  <Flex gridGap={4}>
                    <IconButton
                      isRound
                      icon={<RemoveIcon fontSize="inherit" />}
                      onClick={decSnake}
                      disabled={shake <= 0}
                    />
                    <Input
                      variant="filled"
                      type="number"
                      min={0}
                      max={30}
                      bg="white"
                      value={shake}
                      onChange={(e) => setShake(e.target.value)}
                    />
                    <IconButton
                      isRound
                      icon={<AddIcon fontSize="inherit" />}
                      onClick={incSnake}
                      disabled={shake >= 30}
                    />
                  </Flex>
                </VStack>
              </Box>
              <Box>
                <span>{t("nutrition_section.foods_to_avoid")}</span>
                <Input
                  placeholder="Write food avoid"
                  name="food_avoid"
                  value={foodAvoid}
                  onChange={(e) => setFoodAvoid(e.target.value)}
                />
              </Box>

              <Box>
                <span>{t("nutrition_section.foods_to_include")}</span>
                <Input
                  placeholder="Write food to include"
                  name="food_include"
                  value={foodInclude}
                  onChange={(e) => setFoodInclude(e.target.value)}
                />
              </Box>
              <Button
                onClick={handleSubmit}
                leftIcon={<AutoAwesomeIcon fontSize="inherit" />}
                variant="solid"
                bg="#b42519"
                border="1px solid #b42519"
                _hover={{
                  bg: "white",
                  border: "1px solid #b42519",
                  color: "#b42519",
                }}
                color="white"
                type="submit">
                {t("generate")}
              </Button>
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              w={{ base: "100%", md: "50%" }}
              bg="white"
              h="100vh"
              justifyContent="space-between"
              borderRadius="15px"
              p={5}>
              <Box display="flex" overflowY="scroll">
                {loader ? (
                  <LoadingResponseNutrition />
                ) : (
                  <>
                    <TypingEffect speed={10} text={response} />
                  </>
                )}
              </Box>
              {response && (
                <Box display="flex" justifyContent="space-between" my={2}>
                  <Button onClick={(e) => handleTryAdain(e)}>
                    {t("nutrition_section.generate_another")}
                  </Button>
                  <Button
                    variant="solid"
                    bg="#b42519"
                    border="1px solid #b42519"
                    _hover={{
                      bg: "white",
                      border: "1px solid #b42519",
                      color: "#b42519",
                    }}
                    onClick={onOpen}
                    color="white">
                    {t("save")}
                  </Button>
                </Box>
              )}
            </Box>
          </Box>
          {isOpen && (
            <ModalSaveNutrition
              isOpen={isOpen}
              onClose={onClose}
              initialRef={initialRef}
              client={client}
              clientName={clientName}
              calories={calories}
              protein={protein}
              carbs={carbs}
              fat={fat}
              diet={response}
            />
          )}
        </TabPanel>
        <TabPanel>
          <CustomNutrition />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};

export default Nutrition;
